import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82e21ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plazas restantes:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin entrega de listas:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin de inscripción:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pagos: :", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas entregadas: :", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas legales: :", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de luz:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de oscuridad:", -1))
const _hoisted_9 = { class: "flex-column align-items-center" }
const _hoisted_10 = { class: "text-wrap text-sm" }
const _hoisted_11 = { class: "text-wrap text-sm" }
const _hoisted_12 = { class: "text-wrap text-sm" }
const _hoisted_13 = { class: "text-wrap text-sm" }

import { Torneo, TorneoGestionInfoDTO } from "@/interfaces/Torneo";
import { computed, ref } from "vue";
import ModalModificarTorneo from "./ModalModificarTorneo.vue";
import { getTorneo } from "@/services/TorneosService";
import ModalModificarBasesTorneo from "./ModalModificarBasesTorneo.vue";
import CardAddTorneoLiga from "./CardAddTorneoLiga.vue";
import ModalHandlerMostrarListas from "./ModalHandlerMostrarListas.vue";
import ModalHandlerMostrarClasificacion from "./ModalHandlerMostrarClasificacion.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionTorneo',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const props = __props;
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showModificarTorneoModal = ref<boolean>(false);
const showModificarBasesTorneoModal = ref<boolean>(false);
const showModalHandlerMostrarListas = ref<boolean>(false);
const showModalHandlerMostrarClasificacion = ref<boolean>(false);
const mostrarListas = ref(props.torneo?.torneo.mostrarListas);
const mostrarClasificacion = ref(props.torneo?.torneo.mostrarClasificacion);

const idTorneo = ref<number>(0);
const isLoading = ref<boolean>(false);
const torneoMod = ref<Torneo>({
  idTorneo: 0,
  idUsuario: 0,
  nombreTorneo: "",
  descripcionTorneo: "",
  fechaInicioTorneo: "",
  fechaFinTorneo: "",
  precioTorneo: 0,
  numeroPartidas: 0,
  puntosTorneo: 0,
  estadoTorneo: "ESPERANDO",
  lugarTorneo: "",
  tipoTorneo: "Individual",
  esPrivadoTorneo: false,
  idRangoTorneo: 0,
  esMatchedPlayTorneo: false,
  fechaEntregaListas: "",
  fechaFinInscripcion: "",
  basesTorneo: "",
  cartelTorneo: "",
  metodosPago: [],
  horaInicioTorneo: "",
  horaFinTorneo: "",
  tieneBases: false,
  inicioInscripciones: "",
  listasPorJugador: 0,
  mostrarListas: false,
  mostrarClasificacion: false,
});

const plazasRestantes = computed(() => {
  if (
    !props.torneo ||
    props.torneo.inscripciones.length == undefined ||
    props.torneo.torneo.limiteParticipantes == null
  ) {
    return "Sin límite";
  }
  return (
    props.torneo.torneo.limiteParticipantes - props.torneo.inscripciones.length
  );
});

const listasLuz = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.inscripciones.filter((i) => i.bando === "good").length;
});

const listasOscuridad = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.inscripciones.filter((i) => i.bando === "evil").length;
});

const totalInscripciones = computed(() => {
  return props.torneo ? props.torneo.inscripciones.length : 0;
});

const pagosRealizados = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.inscripciones.filter(
    (inscripcion) => inscripcion.esPago === "SI"
  ).length;
});

const listasLegales = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.inscripciones.filter(
    (inscripcion) => inscripcion.estadoLista === "OK"
  ).length;
});

const listasEntregadas = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.inscripciones.filter(
    (inscripcion) =>
      inscripcion.estadoLista === "ENTREGADA" ||
      inscripcion.estadoLista === "OK" ||
      inscripcion.estadoLista === "ILEGAL"
  ).length;
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const modificarTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const modificarBasesTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarBasesTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const cerrarModal = async () => {
  showModificarBasesTorneoModal.value = false;
  showModificarTorneoModal.value = false;
  showModalHandlerMostrarListas.value = false;
  showModalHandlerMostrarClasificacion.value = false;
};

const onCambioMostrarListas = (nuevoValor: boolean) => {
  mostrarListas.value = nuevoValor;
  showModalHandlerMostrarListas.value = false;
};

const onCambioMostrarClasificacion = (nuevoValor: boolean) => {
  mostrarClasificacion.value = nuevoValor;
  showModalHandlerMostrarClasificacion.value = false;
};

const handlerMostrarListas = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarListas.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarClasificacion = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarClasificacion.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ModalSuccess = _resolveComponent("ModalSuccess")!
  const _component_ModalError = _resolveComponent("ModalError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.torneo)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.torneo.torneo.nombreTorneo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(plazasRestantes.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaEntregaListas)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaFinInscripcion)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(pagosRealizados.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(listasEntregadas.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(listasLegales.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(listasLuz.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(listasOscuridad.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              variant: "tonal",
                              color: "secondary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (modificarTorneo()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Modificar torneo ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              variant: "tonal",
                              color: "secondary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (modificarBasesTorneo()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Modificar bases ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_v_btn, {
                              class: "mt-2",
                              variant: "tonal",
                              color: "secondary",
                              onClick: handlerMostrarListas
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(mostrarListas.value ? "Ocultar" : "Mostrar") + " Listas ", 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_v_btn, {
                                class: "mt-2",
                                variant: "tonal",
                                color: "secondary",
                                onClick: handlerMostrarClasificacion
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mostrarClasificacion.value ? "Ocultar" : "Mostrar") + " Clasificacion ", 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode(_component_v_spacer, { class: "my-4" }),
                          _createVNode(CardAddTorneoLiga, {
                            idTorneo: props.torneo?.torneo.idTorneo!
                          }, null, 8, ["idTorneo"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarTorneo, {
      isVisible: showModificarTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalModificarBasesTorneo, {
      isVisible: showModificarBasesTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarListas, {
      isVisible: showModalHandlerMostrarListas.value,
      torneo: torneoMod.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarListas
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarClasificacion, {
      isVisible: showModalHandlerMostrarClasificacion.value,
      torneo: torneoMod.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarClasificacion
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(_component_ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo modificado con exito.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(_component_ModalError, {
      isVisible: showErrorModal.value,
      message: "No se han podido modificar el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})